/* ATP 5th Anniversary landing page: presale status pill + gentle fade-up reveal.
   Content is fully visible without JS; motion is only armed after this runs. */
(function () {
  function nyDate(d) {
    // YYYY-MM-DD in America/New_York
    try {
      return new Intl.DateTimeFormat("en-CA", { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function initStatus(root) {
    var pill = root.querySelector("[data-atp-status]");
    if (!pill) return;
    var start = pill.getAttribute("data-start");
    var end = pill.getAttribute("data-end");
    if (!start || !end) return;
    var today = nyDate(new Date());
    var state = today < start ? "upcoming" : today > end ? "ended" : "live";
    var label = pill.getAttribute("data-label-" + state);
    if (!label) return;
    pill.textContent = label;
    pill.hidden = false;
  }

  function initReveal(root) {
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var items = root.querySelectorAll(".atp-reveal");
    if (!items.length) return;
    root.classList.add("is-armed");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
    // Safety net: never leave anything hidden.
    setTimeout(function () { items.forEach(function (el) { el.classList.add("is-in"); }); }, 2500);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll(".atp-lp");
    roots.forEach(function (root) {
      if (root.getAttribute("data-atp-ready") === "1") return;
      root.setAttribute("data-atp-ready", "1");
      initStatus(root);
      initReveal(root);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();

  // Re-run when the section is edited in the Shopify theme editor.
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
